/** Abbreviates and rounds down a number if it's 1 million or above (e.g., 2854570 -> 2.8 million).
 * For use in context where we say things like "over 4.1 million" */
export function abbreviateNumber(number: number): string {
  const million = 1000000;
  const billion = 1000000000;

  // between a million and a billion
  if (number >= million && number < billion) {
    const millions = Math.floor((number / million) * 10) / 10;

    return `${millions} million`;
  }

  // a billion or more (#goals)
  if (number >= billion && number < Infinity) {
    const billions = Math.floor((number / billion) * 10) / 10;
    return `${billions} billion`;
  }

  // otherwise just spit the number back out
  return number.toString();
}
